<h4 mat-dialog-title>{{data.date}}
  <ng-container *ngIf="read">
    - Letto
  </ng-container>
  <ng-container *ngIf="warning">
  <span class="material-icons" style="vertical-align: middle; color: rgba(231,180,53,0.92)">
    report_problem
  </span>
  </ng-container>
  <ng-container *ngIf="evaluation">
    <span class="material-icons" style="vertical-align: middle; color: forestgreen">check_circle</span>
  </ng-container>
</h4>
<div mat-dialog-content style="padding-bottom: 20px;">

  <div class="container && mat-elevation-z5">
    <table mat-table [dataSource]="questions">

      <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef> No. </th>
        <td mat-cell *matCellDef="let questionnaire"> {{questionnaire.position}} </td>
      </ng-container>


      <ng-container matColumnDef="question">
        <th mat-header-cell *matHeaderCellDef> Domanda </th>
        <td mat-cell *matCellDef="let questionnaire"> {{questionnaire.question}}
        </td>
      </ng-container>

      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef> Valore </th>
        <td mat-cell *matCellDef="let questionnaire">
          <ng-container *ngIf="this.data.results[questionnaire.position - 1]; else noValue">
            {{this.data.results[questionnaire.position - 1]}}
          </ng-container>
          <ng-template #noValue>
            -
          </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

</div>

<div mat-dialog-actions style="justify-content: center">
  <ng-container *ngIf="data.role.localeCompare('DOTTORE') === 0">
    <button mat-raised-button color="primary" (click)="evaluate()">Valuta</button>
  </ng-container>
  <ng-container *ngIf="data.role.localeCompare('PAZIENTE') === 0">
    <button mat-raised-button color="primary" (click)="warn()">Segnala</button>
  </ng-container>
  <button mat-raised-button color="warn" (click)="cancel()">Esci</button>
</div>

